import {Center, CenterProps} from '@chakra-ui/react'

export interface LoadingContainerProps extends CenterProps {}

export function LoadingContainer(props: LoadingContainerProps) {
  return <Center {...props} flex="auto" position="relative" />
}
